var map = {
	"./backCommodity.png": "Hd4L",
	"./backMoney.png": "J4lW",
	"./changeCommodity.png": "3qys",
	"./patchPay.png": "dAlk",
	"./patchSend.png": "1SAs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cHCj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/replaceType ^\.\/.*$
// module id = cHCj
// module chunks = 0